import { Tabs } from '@mui/material';
import { TabsProps } from '@mui/material/Tabs/Tabs';

import { SolaForceTabsStyleProps, useSxStyles } from './useStyles';

type PropsType = TabsProps & SolaForceTabsStyleProps;

export const SolaForceTabs = (props: PropsType) => {
  const { children, background, shadow, ...rest } = props;
  const sxStyles = useSxStyles({
    background,
    shadow,
    orientation: rest.orientation,
  });

  const tabsProps: TabsProps = {
    variant: 'scrollable',
    ...rest,
    sx: { ...rest.sx, ...sxStyles.tabs },
    slotProps: {
      indicator: {
        sx: sxStyles.tabIndicator,
      },
    },
  };

  return <Tabs {...tabsProps}>{children}</Tabs>;
};
